export default {
      id: "i-message-usage",
      viewBox: "0 0 165 120",
      url: __webpack_public_path__ + "img/sprite.svg#i-message",
      toString: function () {
        return this.url;
      }
    }